import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "empty-block"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "purchase-status" }
const _hoisted_6 = {
  key: 0,
  class: "status-refunded"
}
const _hoisted_7 = {
  key: 1,
  class: "status-active"
}
const _hoisted_8 = {
  key: 2,
  class: "status-cancelled"
}
const _hoisted_9 = {
  key: 3,
  class: "status-pending"
}
const _hoisted_10 = {
  key: 4,
  class: "status-inactive"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_HeaderMessengerButton = _resolveComponent("HeaderMessengerButton")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: _normalizeClass(["ion-no-border events-page-header", { 'page-header--scrolled': _ctx.headerScrolled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    fill: "clear",
                    color: "light",
                    class: "header-menu-btn",
                    onClick: _ctx.openMenu
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.menuOutline,
                        slot: "icon-only"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Мои подписки", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_HeaderMessengerButton)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_content, {
        class: "main-background events-content",
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.load($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Загрузка..."))
              : (_ctx.purchases.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _cache[3] || (_cache[3] = _createElementVNode("p", null, "У вас пока нет подписок.", -1)),
                    _createVNode(_component_router_link, {
                      to: "/showcase",
                      class: "empty-link"
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("На главную", -1)
                      ]))]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createBlock(_component_ion_list, {
                    key: 2,
                    lines: "full"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchases, (p) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: p.id,
                          button: "",
                          onClick: ($event: any) => (_ctx.$router.push(`/subscriptions/${p.subscriptionId}`))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h2", null, _toDisplayString(p.subscriptionTitle || 'Подписка'), 1),
                                (p.expiresAt)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, "до " + _toDisplayString(_ctx.formatDate(p.expiresAt)), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", _hoisted_5, [
                                  (p.refundedAt)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Возврат выполнен"))
                                    : (p.active)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Активна"))
                                      : (p.cancelledAt)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                            _cache[4] || (_cache[4] = _createTextVNode(" Отменена", -1)),
                                            (p.paidAt)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(", ожидается возврат")
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : (!p.paidAt)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Ожидает оплаты"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_10, "Не активна"))
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
          ])
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}